import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components 

import Box from '@mui/material/Box';
import Notification from '../notification/Notification';

interface Props { 
    children: any; 
    extraStyle?: any; 
}; 

const Page: React.FC<Props> = ({ children, extraStyle }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 

    // -- 

    return (

        <Box 
            component="main"
            maxWidth="xs"
            sx={[{ 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center', 
                height: '100vh', 
                width: '100vw',
                left: 0, 
                overflowX: 'hidden',
                overflowY: 'hidden', 
                position: 'absolute',
                color: colors?.text
        }, extraStyle]}>

            {children}

            <Notification />

        </Box>

  );

};

export default Page;